export const extractOfferType = (offerType: string) => {
    const offerTypeMap: any = {
        CO: 'authCashOut',
        SL: 'authRefi',
        RT: 'authRefi',
        PU: 'purchase_widget'
    };

    if (offerType.startsWith('ANC_CO')) {
        return offerTypeMap['CO'];
    } else {
        return offerTypeMap[offerType];
    }
};
